import request from '@/utils/request'

export function getmitmbasp(itmcd) {
  return request({
    url: `/api/mitmbasp/${itmcd}`,
    method: 'get',
  })
}
